var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,42.48100280761719,42.82899856567383)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.78000020980835,3.4019999504089355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M4.530319690704346,-3.147005081176758 C4.530319690704346,-3.147005081176758 4.530099868774414,3.224426031112671 4.530099868774414,3.224426031112671 C4.530099868774414,3.224426031112671 -4.529890060424805,3.224426031112671 -4.529890060424805,3.224426031112671 C-3.588355302810669,0.23212124407291412 -1.1586459875106812,-2.0490071773529053 1.9013296365737915,-2.767005205154419 C2.7673795223236084,-2.9707653522491455 3.6473195552825928,-3.0980050563812256 4.530319690704346,-3.147005081176758z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.21500015258789,42.83000183105469)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,5.14300012588501,6.758999824523926)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M-4.89300012588501,-6.508999824523926 C-4.89300012588501,-6.508999824523926 -4.892750263214111,6.445315361022949 -4.892750263214111,6.445315361022949 C-4.892750263214111,6.445315361022949 4.5602498054504395,6.445315361022949 4.5602498054504395,6.445315361022949 C4.8892340660095215,4.4771857261657715 4.826502323150635,2.4627737998962402 4.368619441986084,0.5130051374435425 C3.591994047164917,-2.7845563888549805 1.0260000228881836,-5.35699987411499 -2.265000104904175,-6.130000114440918 C-3.13100004196167,-6.334000110626221 -4.011000156402588,-6.460000038146973 -4.89300012588501,-6.508999824523926z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.215999603271484,57.527000427246094)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.7789998054504395,3.4019999504089355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M4.542347431182861,-3.214426040649414 C4.542347431182861,-3.214426040649414 -4.530129909515381,-3.2144360542297363 -4.530129909515381,-3.2144360542297363 C-4.530129909515381,-3.2144360542297363 -4.53000020980835,3.1519999504089355 -4.53000020980835,3.1519999504089355 C-3.6480000019073486,3.1029999256134033 -2.7679998874664307,2.9769999980926514 -1.9019999504089355,2.7730000019073486 C1.1449999809265137,2.056999921798706 3.598533868789673,-0.20250153541564941 4.542347431182861,-3.214426040649414z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,41.753997802734375,50.8120002746582)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,5.14300012588501,6.758999824523926)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(244,176,101)",
    fillOpacity: 1,
    d: " M4.89300012588501,6.508999824523926 C4.89300012588501,6.508999824523926 4.893219947814941,-6.4365739822387695 4.893219947814941,-6.4365739822387695 C4.893219947814941,-6.4365739822387695 -4.553536415100098,-6.436674118041992 -4.553536415100098,-6.436674118041992 C-4.881811618804932,-4.471133232116699 -4.819070339202881,-2.4537529945373535 -4.3630051612854,-0.5042640566825867 C-3.5821542739868164,2.791219472885132 -1.0165996551513672,5.358348846435547 2.265000104904175,6.130000114440918 C3.130930185317993,6.33428955078125 4.010000228881836,6.460000038146973 4.89300012588501,6.508999824523926z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.4c68f569d5fb2e004b5e71d9d882c444.svg";
export { ForwardRef as ReactComponent };